export const atendimento = {
  conexoes: () => '/v2/api/atendimento/conexoes',
  syncContatos: (id_conexao) => `/v2/api/atendimento/conexoes/${id_conexao}/sync-contatos`,
  syncChats: (id_conexao) => `/v2/api/atendimento/conexoes/${id_conexao}/sync-chats`,
  refreshChatsList: (id_conexao) =>
    `/v2/api/atendimento/conexoes/${id_conexao}/refresh-chats-list`,
  conversas: () => '/v2/api/atendimento/conversas',
  conversasPoll: () => '/v2/api/atendimento/conversas/poll',
  mensagens: (id_conversa) =>
    `/v2/api/atendimento/conversas/${id_conversa}/mensagens`,
  notasConversa: (id_conversa) =>
    `/v2/api/atendimento/conversas/${id_conversa}/notas`,
  // Vínculos tarefa↔mensagem: endpoint do módulo PM (project-management).
  // Mora no atendimento URL.js porque apiAtendimento.listarVinculosTarefa
  // é quem o consome; o backend mantém pm_task encapsulado no módulo PM.
  vinculosTarefa: () =>
    '/v2/api/aawz-partners/project-management/tasks/links/atendimento-mensagem',
  marcarLida: (id_conversa) =>
    `/v2/api/atendimento/conversas/${id_conversa}/lida`,
  clienteDetalhe: (id_cliente) =>
    `/v2/api/atendimento/clientes/${id_cliente}`,
  mediaUpload: () => '/v2/api/atendimento/media/upload',
  mediaProxy: (id_mensagem) =>
    `/v2/api/atendimento/media/${encodeURIComponent(id_mensagem)}`,
  editarMensagem: (id_mensagem) =>
    `/v2/api/atendimento/mensagens/${id_mensagem}`,
  reagirMensagem: (id_mensagem) =>
    `/v2/api/atendimento/mensagens/${id_mensagem}/reagir`,
  importarHistorico: (id_conversa) =>
    `/v2/api/atendimento/conversas/${id_conversa}/importar-historico`,
  importarAnteriores: (id_conversa) =>
    `/v2/api/atendimento/conversas/${id_conversa}/importar-anteriores`,
  novaConversa: () => '/v2/api/atendimento/conversas/nova',
  buscarContatos: () => '/v2/api/atendimento/contatos/buscar',
  criarContato: () => '/v2/api/atendimento/contatos',
  vincularContato: (id_contato) =>
    `/v2/api/atendimento/contatos/${id_contato}/vincular`,
  autoLinkContato: (id_contato) =>
    `/v2/api/atendimento/contatos/${id_contato}/auto-link`,
  refreshGroupParticipants: (id_contato) =>
    `/v2/api/atendimento/contatos/${id_contato}/refresh-participantes`,
  refreshContatoDados: (id_contato) =>
    `/v2/api/atendimento/contatos/${id_contato}/refresh-dados`,
  renomearContato: (id_contato) =>
    `/v2/api/atendimento/contatos/${id_contato}/renomear`,
  buscarClientes: () => '/v2/api/atendimento/clientes/buscar',
  atribuirConversa: (id_conversa) =>
    `/v2/api/atendimento/conversas/${id_conversa}/atribuir`,
  fecharConversa: (id_conversa) =>
    `/v2/api/atendimento/conversas/${id_conversa}/fechar`,
  escalarConversa: (id_conversa) =>
    `/v2/api/atendimento/conversas/${id_conversa}/escalar`,
  transferirConversa: (id_conversa) =>
    `/v2/api/atendimento/conversas/${id_conversa}/transferir`,
  mudarStatus: (id_conversa) =>
    `/v2/api/atendimento/conversas/${id_conversa}/status`,
  respostasRapidas: () => '/v2/api/atendimento/respostas-rapidas',
  respostaRapida: (id) => `/v2/api/atendimento/respostas-rapidas/${id}`,
  auditoria: () => '/v2/api/atendimento/auditoria',
  deliveryStatus: (id_conversa) =>
    `/v2/api/atendimento/conversas/${id_conversa}/delivery-status`,
}
